if (!customElements.get('podcast-player')) {
  customElements.define('podcast-player', class PodcastPlayer extends HTMLElement {
    constructor() {
      super();

      this.audio = this.querySelector('[data-podcast-audio]');
      this.button = this.querySelector('.podcast-player__surface');
      if (!this.audio || !this.button) return;

      this.icon = this.querySelector('[data-podcast-icon]');
      this.progressFill = this.querySelector('[data-podcast-progress]');
      this.currentTimeEl = this.querySelector('[data-podcast-current]');
      this.durationEl = this.querySelector('[data-podcast-duration]');

      this.button.addEventListener('click', this.togglePlay.bind(this));
      this.audio.addEventListener('timeupdate', this.updateProgress.bind(this));
      this.audio.addEventListener('loadedmetadata', this.updateDuration.bind(this));
      this.audio.addEventListener('ended', this.reset.bind(this));
    }

    togglePlay() {
      if (this.audio.paused) {
        this.audio.play();
        this.setIcon('icon-pause');
      } else {
        this.audio.pause();
        this.setIcon('icon-play');
      }
    }

    reset() {
      this.setIcon('icon-play');
    }

    setIcon(iconName) {
      if (this.icon) this.icon.innerHTML = ICONS[iconName];
    }

    updateDuration() {
      if (this.durationEl) this.durationEl.textContent = this.formatTime(this.audio.duration);
    }

    updateProgress() {
      const percent = (this.audio.currentTime / this.audio.duration) * 100 || 0;
      if (this.progressFill) this.progressFill.style.width = `${percent}%`;
      if (this.currentTimeEl) this.currentTimeEl.textContent = this.formatTime(this.audio.currentTime);
    }

    formatTime(seconds) {
      if (!isFinite(seconds)) return '0:00';
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
      return `${minutes}:${secs}`;
    }
  });
}

const ICONS = {
  'icon-play': '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" fill="none" viewBox="0 0 10 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"/></svg>',
  'icon-pause': '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-pause" fill="none" viewBox="0 0 10 14"><rect x="0" y="0" width="3" height="14" fill="currentColor"/><rect x="7" y="0" width="3" height="14" fill="currentColor"/></svg>'
};
